import { useEffect } from 'react';
import { ResponseError } from 'services/api/base';
import { useLazyGetWindxAboutPdfQuery } from 'services/api/windx';
import { useHandleRequestErrors } from 'utils/hooks';

export default function useInstructionPdf(id: number, triggerRequest: boolean) {
  const [trigger, { data, error, isFetching }] = useLazyGetWindxAboutPdfQuery();

  useEffect(() => {
    if (triggerRequest) {
      trigger({ id });
    }
  }, [triggerRequest, trigger, id]);

  useHandleRequestErrors(error as ResponseError);

  return {
    base64Pdf: data,
    loading: isFetching,
    pdfUrl: data,
  };
}
